<div class="ap-header__navigation vertical-navigation-item vertical-navigation-item--submenu-header">
    @if (navigationItem().type === navigationType.PARENT) {
        <a
            tabindex="0"
            (keydown.enter)="backClicked.emit()"
            (keydown.space)="backClicked.emit()"
            (click)="backClicked.emit()"
            [attr.aria-label]="navigationItem().ariaLabel"
        >
            <asn-icon
                class="ap-header__navigation-chevron--left"
                name="chevron-left"
                color="inherit"
                size="small"
                data-testid="icon-chevron-left"
            >
            </asn-icon>
            {{ navigationItem().label }}
        </a>
    }
    @if (navigationItem().type === navigationType.PARENT_ICON) {
        <button class="ap-header__navigation-icon" [ariaLabel]="navigationItem().ariaLabel" (click)="backClicked.emit()">
            <asn-icon class="ap-header__navigation-chevron--left" name="chevron-left" color="inherit" size="small"></asn-icon>
            <asn-icon [name]="navigationItem().iconName" size="large"></asn-icon>
        </button>
    }
</div>

@for (navigationItem of navigationItem().children; track navigationItem; let last = $last) {
    <ap-vertical-navigation-item
        [navigationItem]="navigationItem"
        [isLastItem]="last"
        (navigationClicked)="navigationClicked.emit(navigationItem)"
    ></ap-vertical-navigation-item>
}
